import React from 'react';
import PropTypes from 'prop-types';
import { Container, Typography, ListItem, Grid, Row, Col } from '@sm/wds-react';
import {
  getNavSubmenuItems,
  getSolutionsByNeedItems
} from './navSubmenuListItems';

import './nav-submenu.scss';

const renderItems = item => {
  const { subTitle = '', title = '', url = '' } = item;
  if (!subTitle) {
    // eslint-disable-next-line jsx-control-statements/jsx-use-if-tag
    return !url ? (
      <ListItem key={title} className="sm-nav-submenu__list-item">
        <Typography
          variant="body"
          color="dark"
          className="sm-nav-submenu__column-title"
        >
          {title}
        </Typography>
      </ListItem>
    ) : (
      // Treat survey types solutions differently
      <a key={title} className="sm-nav-submenu__link-item" href={url}>
        <Typography color="link">{title}</Typography>
      </a>
    );
  }

  return (
    <ListItem
      key={title}
      className="sm-nav-submenu__list-item"
      isNavigable
      navigationTarget={url}
    >
      <Typography
        variant="cardTitle"
        color="link"
        className="sm-nav-submenu__product-title"
      >
        {title}
      </Typography>
      <p className="sm-nav-submenu__product-subtitle">{subTitle}</p>
    </ListItem>
  );
};

export const NavSubmenuColumn = ({ submenuKey, lang, isEUDC }) => {
  const itemsData = getNavSubmenuItems(submenuKey, lang, isEUDC);
  const submenuColumns = itemsData.map(column => {
    const columnData = column.map(items => renderItems(items));
    return (
      <Col key={column[0].title} className="sm-nav-submenu__col">
        {columnData}
      </Col>
    );
  });

  const itemsDataEN = getSolutionsByNeedItems();
  const submenuColumnsEN = itemsDataEN.map(column => {
    const columnData = column.map(items => renderItems(items));
    return (
      <Container
        mt="5"
        mb="5"
        ml="4"
        mr="4"
        key={column[0].title}
        className="sm-nav-submenu__by-need-container"
      >
        {columnData}
      </Container>
    );
  });

  return (
    <Grid noBleeds={lang === 'en'}>
      <Row className="sm-nav-submenu__row">
        <If condition={lang === 'en' && submenuKey === 'Solutions'}>
          <Col className="sm-nav-submenu__col">
            <Typography
              variant="cardTitle"
              color="dark"
              className="sm-nav-submenu__column-title"
            >
              Survey Types
            </Typography>
            {submenuColumnsEN}
          </Col>
        </If>
        {submenuColumns}
      </Row>
    </Grid>
  );
};

NavSubmenuColumn.propTypes = {
  submenuKey: PropTypes.string,
  lang: PropTypes.string,
  isEUDC: PropTypes.bool.isRequired
};

NavSubmenuColumn.defaultProps = {
  submenuKey: 'Solutions',
  lang: 'en'
};

export default NavSubmenuColumn;
